import React from "react";

import { MarkSvg } from "../styles";
import { MarkProps } from "../types";

/** An "A" inside a hexagon. */
const ApexMark = ({ size, ...rest }: MarkProps) => (
  <MarkSvg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest}>
    <path d="M20 3L36 12.2V27.8L20 37L4 27.8V12.2L20 3Z" fill="url(#bo-logo-apex-bg)" />
    <path
      d="M11.5 29L18.7 11.5C19.2 10.3 20.8 10.3 21.3 11.5L28.5 29"
      stroke="#F3F6FC"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15.6 22.2H24.4" stroke="#27B6E4" strokeWidth="2.4" strokeLinecap="round" />
    <path
      d="M23.6 14.2H29.4V20"
      stroke="#56C456"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22.7 20.4L29.1 14.4" stroke="#56C456" strokeWidth="2.3" strokeLinecap="round" />
    <defs>
      <linearGradient id="bo-logo-apex-bg" x1="8" y1="7" x2="33" y2="34" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1B213A" />
        <stop offset="0.48" stopColor="#7748FC" />
        <stop offset="1" stopColor="#27B6E4" />
      </linearGradient>
    </defs>
  </MarkSvg>
);

export default ApexMark;
